module.exports = __webpack_public_path__ + "img/ag.f601041e.png";